import comp from "./DynamicPromptInput";
export default comp;
